module.exports = __webpack_public_path__ + "img/1533736348.2cf033e6.jpg";